import { cloneDeep, each, isEmpty, orderBy, remove, sumBy, toInteger } from 'lodash';
import { ActivityTypeEnum, OffTypeEnum, ProductRelationEnum, UsePromoCodeStatusEnum } from '../enum';
import { findActivityProduct, toFixed } from '../lib/utils';
/**
 * 处理满N免N
 * @param theSameItemMap
 * @param itemMap
 * @param fullItemNFreeActivitys
 * @param productAllOff
 * @returns
 */
export default function calFullItemNFree2(opt) {
    const { theSameItemMap, itemMap, enablePromoCodeActivity, fullItemNFreeMap, alearedJoinFullItemPks, notJoinFullItemPks, } = opt;
    let { usePromoCodeStatus, fullItemNFreeActivitys, productAllOff } = opt;
    const joinProductKeyActivityId = {};
    if (!isEmpty(theSameItemMap)) {
        fullItemNFreeActivitys = orderBy(fullItemNFreeActivitys, ['extra.freeFullProportion', 'extra.fullCnt', 'extra.freeCnt'], ['desc', 'asc', 'desc']);
        each(fullItemNFreeActivitys, (activity) => {
            var _a, _b;
            if (activity.promoCode && usePromoCodeStatus === UsePromoCodeStatusEnum.Unused) {
                usePromoCodeStatus = UsePromoCodeStatusEnum.Ineffective;
            }
            const fullCnt = toInteger((_a = activity.extra) === null || _a === void 0 ? void 0 : _a.fullCnt) || 1;
            const freeCnt = toInteger((_b = activity.extra) === null || _b === void 0 ? void 0 : _b.freeCnt) || 1;
            const pushFreePks = new Set();
            each(theSameItemMap, (theSameItem, key) => {
                const theSameItems = [];
                let sumProductCnt = 0;
                each(theSameItem, (item) => {
                    if (!item.orderDetailId) {
                        sumProductCnt += item.cnt || 0;
                        for (let i = 0; i < (item.cnt || 0); i++) {
                            theSameItems.push(Object.assign(Object.assign({}, item), { cnt: 1 }));
                        }
                    }
                });
                const allProcudtFreeCnt = Math.floor(sumProductCnt / fullCnt) * freeCnt;
                let allSurplusCnt = 0;
                if (sumProductCnt >= fullCnt) {
                    const relatedPks = new Set([]);
                    let abandonedCnt = 0;
                    each(theSameItems, (product) => {
                        if (!alearedJoinFullItemPks.includes(product.pk || '') && !notJoinFullItemPks.includes(product.pk || '')) {
                            let joinActitity = false;
                            if (activity.productRelation !== ProductRelationEnum.All) {
                                const findProduct = findActivityProduct(activity.productMap, product);
                                if (findProduct && activity.productRelation === ProductRelationEnum.Included) {
                                    joinActitity = true;
                                }
                                else if (!findProduct && activity.productRelation === ProductRelationEnum.Excluded) {
                                    joinActitity = true;
                                }
                            }
                            else {
                                joinActitity = true;
                            }
                            if (joinActitity) {
                                if (!joinProductKeyActivityId[key]) {
                                    joinProductKeyActivityId[key] = activity.activityId;
                                }
                            }
                            if (joinActitity && joinProductKeyActivityId[key] === activity.activityId) {
                                const id = product.pk || product.productNo + '_' + product.scaleNo;
                                const beforeOff = product.off || 0;
                                let procudtFreeCnt = abandonedCnt + (product.cnt || 0) === fullCnt ? freeCnt : 0;
                                relatedPks.add(id);
                                if (procudtFreeCnt <= 0) {
                                    abandonedCnt += product.cnt || 0;
                                    return;
                                }
                                else {
                                    abandonedCnt = 0;
                                }
                                if (allSurplusCnt >= allProcudtFreeCnt) {
                                    return;
                                }
                                if (procudtFreeCnt <= 0) {
                                    procudtFreeCnt = 0;
                                    return;
                                }
                                allSurplusCnt += procudtFreeCnt;
                                if (fullItemNFreeMap[id]) {
                                    fullItemNFreeMap[id].activityProduct.pk = id;
                                    fullItemNFreeMap[id].validProduct = product;
                                    fullItemNFreeMap[id].maxFreeCnt += procudtFreeCnt;
                                    fullItemNFreeMap[id].surplusCnt += procudtFreeCnt;
                                    fullItemNFreeMap[id].relatedPks.push(...relatedPks);
                                }
                                else {
                                    fullItemNFreeMap[id] = {
                                        activityProduct: {
                                            categoryNo: product.categoryNo,
                                            productNo: product.productNo,
                                            scaleNo: product.scaleNo,
                                            pk: id,
                                        },
                                        maxFreeCnt: procudtFreeCnt,
                                        activityName: activity.activityName,
                                        surplusCnt: procudtFreeCnt,
                                        validProduct: product,
                                        relatedPks: [...relatedPks],
                                    };
                                }
                                let allProductCnt = sumBy(product === null || product === void 0 ? void 0 : product.fullItemNFreeProducts, 'cnt');
                                const nowOff = toFixed(product.price * allProductCnt);
                                if (beforeOff < nowOff) {
                                    const fullItemNFreeProduct = (product === null || product === void 0 ? void 0 : product.fullItemNFreeProducts) && product.fullItemNFreeProducts[0];
                                    if (fullItemNFreeProduct) {
                                        let fullItemNFreeProducts = [];
                                        if (allProductCnt > allProcudtFreeCnt) {
                                            let countFreeCnt = 0;
                                            each(product === null || product === void 0 ? void 0 : product.fullItemNFreeProducts, (fullItemNFreeProduct) => {
                                                if (countFreeCnt <= allProcudtFreeCnt) {
                                                    let pushCnt = fullItemNFreeProduct.cnt || 0;
                                                    if (allProcudtFreeCnt - countFreeCnt < pushCnt) {
                                                        pushCnt = allProcudtFreeCnt - countFreeCnt;
                                                    }
                                                    fullItemNFreeProduct.cnt = pushCnt;
                                                    fullItemNFreeProduct.relatedPks = [...relatedPks];
                                                    if (pushCnt > 0) {
                                                        fullItemNFreeProducts.push(fullItemNFreeProduct);
                                                    }
                                                    countFreeCnt += pushCnt;
                                                }
                                            });
                                            allProductCnt = allProcudtFreeCnt;
                                        }
                                        else {
                                            fullItemNFreeProducts = (product === null || product === void 0 ? void 0 : product.fullItemNFreeProducts) || [];
                                        }
                                        productAllOff -= beforeOff;
                                        removeNotFullItem(itemMap, id);
                                        const surplusCnt = fullItemNFreeMap[id].surplusCnt - allProductCnt;
                                        fullItemNFreeMap[id].surplusCnt = surplusCnt;
                                        if (fullItemNFreeMap[id].surplusCnt < 0) {
                                            fullItemNFreeMap[id].surplusCnt = 0;
                                        }
                                        each(fullItemNFreeProducts, (fullItemNFreeProduct) => {
                                            const freeId = fullItemNFreeProduct.pk || fullItemNFreeProduct.productNo + '_' + fullItemNFreeProduct.scaleNo;
                                            removeNotFullItem(itemMap, freeId, fullItemNFreeProduct.key || '');
                                            if (!itemMap[freeId]) {
                                                itemMap[freeId] = {
                                                    items: [],
                                                    itemAllOff: 0,
                                                };
                                            }
                                            if (((fullItemNFreeProduct === null || fullItemNFreeProduct === void 0 ? void 0 : fullItemNFreeProduct.cnt) || 0) > 0 && !pushFreePks.has(fullItemNFreeProduct.pk || '')) {
                                                pushFreePks.add(fullItemNFreeProduct.pk || '');
                                                const freeOff = fullItemNFreeProduct.price * (fullItemNFreeProduct.cnt || 0);
                                                itemMap[freeId].items.push(Object.assign(Object.assign({}, fullItemNFreeProduct), { off: fullItemNFreeProduct.price * (fullItemNFreeProduct.cnt || 0), offId: activity.activityId, offTip: activity.activityName, offType: activity.promoCode ? OffTypeEnum.PromoCode : OffTypeEnum.Activity, activity: activity, cnt: fullItemNFreeProduct.cnt, isIncludeModifier: activity.isIncludeModifier || false, relatedPks: [...((fullItemNFreeProduct === null || fullItemNFreeProduct === void 0 ? void 0 : fullItemNFreeProduct.relatedPks) || cloneDeep(relatedPks))] }));
                                                itemMap[freeId].itemAllOff += freeOff;
                                                relatedPks.clear();
                                            }
                                        });
                                        productAllOff += nowOff;
                                        if (activity.promoCode) {
                                            if (usePromoCodeStatus === UsePromoCodeStatusEnum.Ineffective) {
                                                usePromoCodeStatus = UsePromoCodeStatusEnum.Effective;
                                            }
                                            enablePromoCodeActivity.push(activity.activityId);
                                        }
                                    }
                                }
                                else {
                                    if (beforeOff > 0 && (product === null || product === void 0 ? void 0 : product.fullItemNFreeProducts)) {
                                        // fullItemNFreeMap[id].maxFreeCnt = 0;
                                        fullItemNFreeMap[id].surplusCnt = 0;
                                    }
                                }
                            }
                        }
                    });
                }
            });
        });
    }
    return { fullItemNFreeMap, itemMap, usePromoCodeStatus, enablePromoCodeActivity, productAllOff };
}
/**
 * 删除不是第几个打折的商品
 * @param itemMap
 * @param id
 */
const removeNotFullItem = (itemMap = {}, id, key = '') => {
    if (itemMap[id]) {
        if (key) {
            remove(itemMap[id].items, (item) => {
                return item.key === key;
            });
            return;
        }
        each(itemMap[id].items, (item, index) => {
            if (item && item.offType !== OffTypeEnum.Coupon && item.offType !== OffTypeEnum.Plan) {
                if (!item.activity ||
                    (item.activity &&
                        item.activity.type !== ActivityTypeEnum.NthItemNDiscount &&
                        item.activity.type !== ActivityTypeEnum.FullItemNFree &&
                        item.activity.type !== ActivityTypeEnum.GroupBuy)) {
                    itemMap[id].itemAllOff -= item.off;
                    remove(itemMap[id].items, (item, idx) => {
                        return index === idx;
                    });
                    return;
                }
            }
        });
    }
};
//# sourceMappingURL=calFullItemNFree2.js.map